/* import "./jquery-global.js";
import $ from "jquery"; */

// import { Collapse} from 'bootstrap'; /* not reliable */
// import "/node_modules/bootstrap/js/src/collapse.js"; /* reliable */
import Collapse from 'bootstrap/js/dist/collapse'; /* reliable */
import Tab from 'bootstrap/js/dist/tab'; /* reliable */
import Doopdown from 'bootstrap/js/dist/dropdown'; /* reliable */

import "./custom.js";

import "./modules/module-heroswiper/module-heroswiper.js";
import "./modules/module-teaserswiper/module-teaserswiper.js";
import "./modules/module-serviceswiper/module-serviceswiper.js";
import "./modules/module-bigteaserswiper/module-bigteaserswiper.js";
import "./modules/module-smallteaserswiper/module-smallteaserswiper.js";
import "./modules/module-objectdetail/module-objectdetail.js";
import "./modules/module-map/module-map.js";
import "./modules/module-careerswiper/module-careerswiper.js";
import "./modules/module-immolist/module-immolist.js";
import "./modules/module-immodetail/module-immodetail.js";
import "./modules/module-imageswiper/module-imageswiper.js";